var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 22,
    viewBox: "0 0 12 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.92414 21.1482V11.5185H0.667969V7.76554H3.92414V4.99788C3.92414 1.78603 5.89524 0.0371094 8.77419 0.0371094C10.1532 0.0371094 11.3385 0.139292 11.6839 0.184964V3.54154L9.68715 3.54244C8.12142 3.54244 7.81825 4.2829 7.81825 5.36947V7.76554H11.5524L11.0662 11.5185H7.81825V21.1482H3.92414Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbFooter);
export default __webpack_public_path__ + "static/media/fb-footer.ae12375ef76df73ebaeb2ad533f6cc95.svg";
export { ForwardRef as ReactComponent };